/* == THE UNDIMMED - 3D EXPERIENCE ==
   Desktop: mouse tilt + glare on ud-cards, mouse parallax heroes.
   Mobile: scroll-driven card tilt + scroll parallax heroes.
   Shared: depth reveals, floating light motes.
   Delegation + MutationObserver so effects survive Horizon's
   view transitions and section hydration. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var HERO_SEL = '.ud-hub-hero, .ud-comm-hero';

  /* -- Depth reveals (all devices, re-registers after DOM swaps) -- */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        io.unobserve(el);
        el.addEventListener('transitionend', function handler() {
          el.classList.remove('ud-reveal', 'is-in');
          el.style.transitionDelay = '';
          el.removeEventListener('transitionend', handler);
        });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  }

  function registerReveals(root) {
    if (!io || !root || !root.querySelectorAll) return;
    var els = root.querySelectorAll('.ud-card, .ud-chapter-card, .ud-paid-guide__chapter, .undimmed-section .ud-h2, .undimmed-section .ud-eyebrow');
    var i = 0;
    els.forEach(function (el) {
      if (el.dataset.ud3d) return;
      if (el.closest(HERO_SEL)) return;
      el.dataset.ud3d = '1';
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0 && r.top >= 0) return;
      el.classList.add('ud-reveal');
      el.style.transitionDelay = (i % 3) * 80 + 'ms';
      io.observe(el);
      i++;
    });
  }
  registerReveals(document);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) { registerReveals(n); initHeroes(); }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* -- Heroes: motes + parallax element map (re-init after page swaps) -- */
  var plxEls = [];
  function initHeroes() {
    document.querySelectorAll(HERO_SEL).forEach(function (hero) {
      if (hero.dataset.ud3d) return;
      hero.dataset.ud3d = '1';
      plxEls = [];
      var inner = hero.querySelector('.ud-container');
      if (inner) {
        var depths = [8, 16, 12, 10, 9, 8, 7];
        Array.prototype.forEach.call(inner.children, function (el, i) {
          plxEls.push({ el: el, depth: depths[i] || 7 });
        });
      }
      for (var m = 0; m < 9; m++) {
        var mote = document.createElement('span');
        mote.className = 'ud-mote';
        mote.setAttribute('aria-hidden', 'true');
        var size = 2.5 + Math.random() * 4;
        mote.style.width = size + 'px';
        mote.style.height = size + 'px';
        mote.style.left = (5 + Math.random() * 90) + '%';
        mote.style.bottom = (5 + Math.random() * 60) + '%';
        mote.style.animationDuration = (8 + Math.random() * 9) + 's';
        mote.style.animationDelay = (Math.random() * 7) + 's';
        hero.appendChild(mote);
      }
      if (finePointer) bindHeroMouse(hero);
    });
  }

  function bindHeroMouse(hero) {
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
    function tick() {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      plxEls.forEach(function (p) {
        p.el.style.transform = 'translate3d(' + (cx * p.depth).toFixed(2) + 'px,' + (cy * p.depth).toFixed(2) + 'px,0)';
      });
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) { raf = requestAnimationFrame(tick); } else { raf = null; }
    }
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(tick);
    });
    hero.addEventListener('mouseleave', function () {
      tx = 0; ty = 0;
      if (!raf) raf = requestAnimationFrame(tick);
    });
  }
  initHeroes();

  if (finePointer) {
    /* -- Desktop: delegated tilt + glare on ud-cards -- */
    document.addEventListener('mousemove', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('.ud-card') : null;
      if (!card) return;
      if (!card.querySelector(':scope > .ud-glare')) {
        var g = document.createElement('span');
        g.className = 'ud-glare';
        g.setAttribute('aria-hidden', 'true');
        card.appendChild(g);
      }
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transition = 'transform 0.12s ease-out, box-shadow 0.25s ease';
      card.style.transform = 'perspective(900px) rotateX(' + (y * -6).toFixed(2) + 'deg) rotateY(' + (x * 7).toFixed(2) + 'deg) translateY(-4px)';
      card.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%');
      card.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('.ud-card') : null;
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      card.style.transition = 'transform 0.45s ease, box-shadow 0.25s ease';
      card.style.transform = '';
    }, { passive: true });
  } else {
    /* -- Mobile: scroll-driven 3D -- */
    var ticking = false;
    function mobileTick() {
      var vh = window.innerHeight;
      document.querySelectorAll('.ud-card').forEach(function (card) {
        if (card.classList.contains('ud-reveal')) return;
        var r = card.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) {
          if (card.style.transform) card.style.transform = '';
          return;
        }
        var d = (r.top + r.height / 2 - vh / 2) / (vh / 2);
        d = Math.max(-1, Math.min(1, d));
        card.style.transition = 'none';
        card.style.transform = 'perspective(900px) rotateX(' + (d * 4).toFixed(2) + 'deg)';
      });
      var y = window.scrollY || window.pageYOffset || 0;
      if (y < window.innerHeight * 1.5) {
        plxEls.forEach(function (p) {
          p.el.style.transform = 'translate3d(0,' + (y * p.depth * -0.012).toFixed(2) + 'px,0)';
        });
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(mobileTick); }
    }, { passive: true });
    mobileTick();
  }
})();
